import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';
import { PageTitle, StandardTable } from '@cordata/buffet';
import { format } from 'date-fns';
import { onMarkAsDone } from '~/components/Reminder/Home/ListGroupItem';

const dateDisplayFormat = 'MM/DD/YYYY';
const remindersUrl = 'data/public/home-page-notifications-view';

const navigateToCell = data => (
  <Link to={`/patients/${data.row._original.attributes.patientUid}/details`}>
    {data.value}
  </Link>);

const defaultSorted = [{
  id: 'reminderDate',
  desc: true,
}];

const columns = [{
  id: 'patientFirstName',
  Header: 'Patient First Name',
  accessor: 'attributes.patientFirstName',
  minWidth: 50,
  Cell: navigateToCell,
}, {
  id: 'patientLastName',
  Header: 'Patient Last Name',
  accessor: 'attributes.patientLastName',
  minWidth: 50,
  Cell: navigateToCell,
}, {
  id: 'note',
  Header: 'Reminder',
  accessor: 'attributes.note',
  Cell: navigateToCell,
}, {
  id: 'displayName',
  Header: 'Assgined To',
  accessor: 'attributes.displayName',
  minWidth: 50,
  Cell: navigateToCell,
}, {
  id: 'reminderDate',
  Header: 'Due',
  accessor: 'attributes.reminderDate',
  minWidth: 25,
  Cell: data => (
    <Link to={`/patients/${data.row._original.attributes.patientUid}/details`}>
      {format(data.value, dateDisplayFormat)}
    </Link>),
}, {
  Cell: data => (
    <Button
      color="tertiary"
      size="sm"
      outline
      block
      onClick={() => onMarkAsDone({
        id: data.original.id,
        reminderType: data.original.attributes.notificationType,
        ...data.original.attributes, // dumb
      })}
    >
      <FontAwesomeIcon icon="check" />
      <span className="d-none d-md-inline pl-2"><span className="d-none d-xl-inline">Mark as </span>Done</span>
    </Button>
  ),
  filterable: false,
  sortable: false,
  minWidth: 50,
}];

const AllRemindersIndex = () => (
  <>
    <PageTitle>Reminders</PageTitle>

    <StandardTable
      defaultSorted={defaultSorted}
      endpoint={remindersUrl}
      columns={columns}
    />
  </>
);

export default AllRemindersIndex;
